// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 36) return "static/js/4b07a118a9184c0515af.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"470bf693a0d5427059e1","175":"c9ed7fb86626a8261dea","176":"891694c2693d59380e79"}[chunkId] + ".chunk.js";
};